const colors = {
	primaryBlue: '#003087',
	primaryLightBlue: '#0070BA',
	secondaryBlue: '#009cde',
	linkBlue: '#0270ba',

	gray1: '#b7bcbf',
	lightestGray: '#e9e9e9',

	black: '#2c2e2f' // Used by input fields
}

export default colors;